import main from './main'

export class teras extends main{

   constructor (args) {
      super(args)
      this.name = 'avb.sigenp.org'
      this.version = '1.0.1'
      this.urlsite = (process.env.NODE_ENV != 'development') ? document.location.origin + '/site/' : ''
      this.page = {
         title: 'Home'
      }

      this.apiUrl = 'https://api.avb-sigenp.org:14439/201806/'
      this.mysql = {
         composer:'db',
         adapter:'avb',
         database:'sigenp_avb'
      }
   
      
      this._evento=[]
      super.init()
      return this
   }

 
}
export default new teras
